/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimSummary
 */
export interface ClaimSummary {
    /**
     * 
     * @type {string}
     * @memberof ClaimSummary
     */
    claimNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimSummary
     */
    primaryClient: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimSummary
     */
    insured: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimSummary
     */
    broker: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimSummary
     */
    dateOfLoss: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimSummary
     */
    lastAccessedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof ClaimSummary
     */
    lossLocation: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimSummary
     */
    instructedDate: Date;
    /**
     * 
     * @type {string}
     * @memberof ClaimSummary
     */
    cause: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimSummary
     */
    status: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimSummary
     */
    claimType: string | null;
}

/**
 * Check if a given object implements the ClaimSummary interface.
 */
export function instanceOfClaimSummary(value: object): value is ClaimSummary {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('primaryClient' in value) || value['primaryClient'] === undefined) return false;
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('broker' in value) || value['broker'] === undefined) return false;
    if (!('dateOfLoss' in value) || value['dateOfLoss'] === undefined) return false;
    if (!('lastAccessedAt' in value) || value['lastAccessedAt'] === undefined) return false;
    if (!('lossLocation' in value) || value['lossLocation'] === undefined) return false;
    if (!('instructedDate' in value) || value['instructedDate'] === undefined) return false;
    if (!('cause' in value) || value['cause'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('claimType' in value) || value['claimType'] === undefined) return false;
    return true;
}

export function ClaimSummaryFromJSON(json: any): ClaimSummary {
    return ClaimSummaryFromJSONTyped(json, false);
}

export function ClaimSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'primaryClient': json['primaryClient'],
        'insured': json['insured'],
        'broker': json['broker'],
        'dateOfLoss': (new Date(json['dateOfLoss'])),
        'lastAccessedAt': (new Date(json['lastAccessedAt'])),
        'lossLocation': json['lossLocation'],
        'instructedDate': (new Date(json['instructedDate'])),
        'cause': json['cause'],
        'status': json['status'],
        'claimType': json['claimType'],
    };
}

export function ClaimSummaryToJSON(value?: ClaimSummary | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'primaryClient': value['primaryClient'],
        'insured': value['insured'],
        'broker': value['broker'],
        'dateOfLoss': ((value['dateOfLoss']).toISOString().substring(0,10)),
        'lastAccessedAt': ((value['lastAccessedAt']).toISOString().substring(0,10)),
        'lossLocation': value['lossLocation'],
        'instructedDate': ((value['instructedDate']).toISOString().substring(0,10)),
        'cause': value['cause'],
        'status': value['status'],
        'claimType': value['claimType'],
    };
}

